import {
    GET_SHARE_TEMPLATE,
    UPDATE_TEMPLATE_DETAILS,
    DELETE_TEMPLATE,
    MORE_CREATE_PRODUCT_TEMPLATE,
    GET_DETAILED_PRODUCT_TEMPLATE_LIST,
    GET_USER_LIST,
    GET_TEMPLATE_DETAILS,
    GET_FILTER_SEARCH_DATA,
} from 'src/pages/more/pages/templates/redux/action/actionTypes.js';
import {shareTemplate} from './shareTemplateSaga';
import {updateTemplateDetails} from './updateTemplateSaga';
import {createEquityProductTemplate}from './createTemplateSaga';
import {getTemplate} from './getTemplateSaga';
import {deleteTemplates} from './deleteTemplateSaga';
import { fork, all, takeLatest } from 'redux-saga/effects';
import {getUserList} from './userListSaga';
import {getTemplateDetails} from './getTemplateDetailsSaga';
import {filterSearch} from './filterSearchSaga';
// import {validateProductsEquitySaga} from './validateProductsEquitySaga';
// import {validateProductsSurgerySaga} from './validateProductsSurgerySaga';

function* watchGetTemplatesSaga() {
    yield takeLatest(
        GET_DETAILED_PRODUCT_TEMPLATE_LIST,
        getTemplate
    );
}

function* watchGetTemplateDetailsSaga() {
    yield takeLatest(
        GET_TEMPLATE_DETAILS,
        getTemplateDetails
    );
}

function* watchUserListSaga() {
    yield takeLatest(GET_USER_LIST, getUserList);
}

function* watchShareTemplateSaga() {
    yield takeLatest(GET_SHARE_TEMPLATE, shareTemplate);
}

function* watchUpdateTemplateDetails() {
    yield takeLatest(UPDATE_TEMPLATE_DETAILS, updateTemplateDetails);
}


function* watchDeleteTemplateSaga() {
    yield takeLatest(DELETE_TEMPLATE, deleteTemplates);
}

function* watchCreateTemplateDetails() {
    yield takeLatest(MORE_CREATE_PRODUCT_TEMPLATE, createEquityProductTemplate);
}

// function* watchValidateProductsEquitySaga() {
//     yield takeLatest(MORE_TEMPLATES_VALIDATE_PRODUCTS_EQUITY, validateProductsEquitySaga);
// }

// function* watchValidateProductsSurgerySaga() {
//     yield takeLatest(MORE_TEMPLATES_VALIDATE_PRODUCTS_EQUITY, validateProductsSurgerySaga);
// }
function* watchFilterSearchSaga() {
    yield takeLatest(GET_FILTER_SEARCH_DATA, filterSearch);
}

export default function* moreTemplateRootSaga() {
    yield all([
        fork(watchShareTemplateSaga),
        fork(watchDeleteTemplateSaga),
        fork(watchUpdateTemplateDetails),
        fork(watchCreateTemplateDetails),
        fork(watchGetTemplatesSaga),
        fork(watchUserListSaga),
        fork(watchGetTemplateDetailsSaga),
        fork(watchFilterSearchSaga),
        // fork(watchValidateProductsEquitySaga),
        // fork(watchValidateProductsSurgerySaga),
    ]);
}
